'use strict';

var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

/**
 * The default avatar image
 */
const AvatarDefaultSvg = ({ size, foregroundColor, backgroundColor, }) => {
    return (React__default['default'].createElement("svg", { fill: "none", width: size, height: size, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", role: "presentation" },
        React__default['default'].createElement("mask", { id: "default-user-avatar-mask", height: "24", maskUnits: "userSpaceOnUse", width: "24", x: "0", y: "0" },
            React__default['default'].createElement("path", { d: "m0 0h24v24h-24z", fill: "#fff" })),
        React__default['default'].createElement("g", { mask: "url(#default-user-avatar-mask)" },
            React__default['default'].createElement("path", { d: "m0 0h24v24h-24z", fill: backgroundColor }),
            React__default['default'].createElement("g", { fill: foregroundColor },
                React__default['default'].createElement("ellipse", { cx: "12", cy: "26", rx: "16", ry: "10" }),
                React__default['default'].createElement("circle", { cx: "12", cy: "10", r: "4" })))));
};

module.exports = AvatarDefaultSvg;
